import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor — attach token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor — handle 401
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      // Keep the requested URL (incl. query) so login can send the user back to it
      const { pathname, search, hash } = window.location;
      if (!pathname.startsWith('/login')) {
        window.location.href = `/login?next=${encodeURIComponent(pathname + search + hash)}`;
      }
    }
    return Promise.reject(error);
  }
);

export default api;
